module.exports = __webpack_public_path__ + "img/menu_item_document.ff7e4393.svg";